import Icon from '../components/Icon.vue'

Icon.register({"arrow-circle-left":{"width":1536,"height":1792,"paths":[{"d":"M1280 960v-128q0-26-19-45t-45-19h-502l189-189q19-19 19-45t-19-45l-91-91q-18-18-45-18t-45 18l-362 362-91 91q-18 18-18 45t18 45l91 91 362 362q18 18 45 18t45-18l91-91q18-18 18-45t-18-45l-189-189h502q26 0 45-19t19-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-circle-left.js
// module id = 843
// module chunks = 0